import React, { useContext } from "react";
import { imgJudgeBusinessSchool } from "../../assets/assetsExport";
import { useSelector } from "react-redux";
import { getIsNarrowScreen, getLang } from "../../features/app/appSlice";
import SlideUpAnimation from "../SlideUpAnimation/SlideUpAnimation";

export default function Publication({
  withTitle = false,
}: {
  withTitle?: boolean;
}) {
  const lang = useSelector(getLang);
  const isSmallScreen = useSelector(getIsNarrowScreen);
  return (
    <div className="border-t border-black pt-6 my-32">
      {withTitle && (
        <h2 className="font-header text-3xl mb-10 leading-normal text-secondary-dark">
          {lang ? "University of Cambridge Publication" : "剑桥大学报道"}
        </h2>
      )}
      <SlideUpAnimation>
        <a
          href="https://www.jbs.cam.ac.uk/2021/new-vision-for-cambridge-emba-alumni/"
          target="_blank"
          rel="noopener noreferrer"
          className="group block bg-secondary-light overflow-hidden"
        >
          <div className="flex flex-col sm:flex-row">
            <div className="relative w-full sm:w-1/2 h-[300px] sm:h-auto sm:min-h-[420px] overflow-hidden">
              <img
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                src={imgJudgeBusinessSchool}
                alt={lang ? "Cambridge Judge Business School" : "剑桥Judge商学院"}
              />
            </div>
            <div className="w-full sm:w-1/2 p-8 sm:p-10 flex flex-col justify-between gap-6">
              <div>
                <p className="text-[11px] tracking-[0.3em] uppercase text-main font-medium pb-4">
                  {lang ? "FEATURED" : "特别报道"}
                </p>
                <p className="font-header text-2xl sm:text-3xl leading-snug text-secondary-dark flex flex-col lg:flex-row">
                  {lang ? (
                    <span>New vision for Cambridge EMBA alumni</span>
                  ) : (
                    <>
                      <span>剑桥EMBA校友的</span>
                      <span>新愿景</span>
                    </>
                  )}
                </p>
                <p className="py-5 text-[14px] leading-7 text-secondary-dark/80">
                  {lang
                    ? "New Vision Group continues to achieve remarkable success in its development. The University of Cambridge conducted an exclusive interview with the founding management team of New Vision, sharing the group's development philosophy and significant achievements."
                    : "新愿景集团在发展中不断收获喜讯。英国剑桥大学专访了新愿景创始管理团队，分享集团的发展理念和显著成就。"}
                </p>
              </div>
              <span className="bg-secondary-dark text-white px-4 py-2 font-medium text-xs tracking-[0.2em] uppercase self-start group-hover:bg-main transition-colors">
                {lang ? "Read More" : "阅读更多"}
              </span>
            </div>
          </div>
        </a>
      </SlideUpAnimation>
    </div>
  );
}
